var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBellOffLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12562_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3254 9.1795L8.00488 24.5L9.04196 25.5371L24.3625 10.2166L23.3254 9.1795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7333 19.8V14.6667C10.7333 11.7333 13.0666 9.4 15.9999 9.4C17.3999 9.4 18.6666 9.93333 19.6666 10.8667L20.6666 9.8C19.5999 8.8 18.2666 8.13333 16.7333 7.93333V6H15.2666V8C11.8666 8.33333 9.2666 11.2 9.2666 14.6667V21.2667L10.7333 19.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7334 21.2667V14.6667C22.7334 13.2667 22.3334 12 21.6 10.9333L20.6 12C21.0667 12.8 21.3334 13.6667 21.3334 14.6667V21.2667H18H14H11.3334L9.8667 22.7333H10H13.2667V24C13.2667 25.5333 14.4667 26.7333 16 26.7333C17.5334 26.7333 18.7334 25.5333 18.7334 24V22.7333H22H24.6667V21.2667H22.7334ZM17.2667 24C17.2667 24.6667 16.6667 25.2667 16 25.2667C15.3334 25.2667 14.7334 24.6667 14.7334 24V22.7333H17.2667V24Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12562_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 20.7333,
    fill: "white",
    transform: "translate(8 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellOffLight);
export default __webpack_public_path__ + "static/media/icon_bell_off_light.62916ffd.svg";
export { ForwardRef as ReactComponent };